import React from 'react';
import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import { ComboBox, DefaultButton, Label } from '@fluentui/react';
import { RootState } from '../state/RootState';

import logo from '../img/FullLogo_Transparent_LightBG.png';
import { IMsalContext } from '@azure/msal-react';
import { MSALConfigGen } from '../authConfig';
import API, { IMemberTenantInfo } from '../API';

export class MSALSignInState {
	
	msalContext: IMsalContext;
	selectedTenantInfo?: IMemberTenantInfo;
	storedTenants: IMemberTenantInfo[];
	activeTenantId: string;


	constructor(msalContext:IMsalContext) {
		this.msalContext = msalContext;	
		this.activeTenantId = MSALConfigGen.getActiveTenantId() || '';
		this.storedTenants = MSALConfigGen.getStoredTenants();

		makeAutoObservable(this);
	}

	public currentTenantUrl:string = '';
	public setCurrentTenantUrl(tenantUrl:string) {
		this.currentTenantUrl = tenantUrl;
	}

	public addToStoredTenants(tenant:IMemberTenantInfo) {
		//Add to stored tenants if not already there
		if(!this.storedTenants.find(t => t.id === tenant.id)) {
			this.storedTenants.push(tenant);
			MSALConfigGen.setStoredTenants(this.storedTenants);
		}
	}

	public async startLogin() {
		

		//Does the tenant info match what they've typed?
		if(this.currentTenantUrl && this.selectedTenantInfo?.domain !== this.currentTenantUrl) {

			//Look for it
			this.selectedTenantInfo = this.storedTenants.find(t => t.domain.toLowerCase() === this.currentTenantUrl.toLowerCase());

			if(!this.selectedTenantInfo) {
				//Need to load it from the server
				let api = new API('');
				this.selectedTenantInfo = await api.getTenantInfo(this.currentTenantUrl);
				this.addToStoredTenants(this.selectedTenantInfo);
			}
		}			

		//Save off the tenant ID for the login process. It could be blank for the home tenant.
		MSALConfigGen.setActiveTenantId(this.selectedTenantInfo?.id || '');
		
		//Remove any existing msal.interaction.status from session storage 
		window.sessionStorage.removeItem('msal.interaction.status');
		
		this.msalContext.instance.loginRedirect({
			prompt: "select_account",
			scopes: [".default"]
		});
	}
}

export interface IMSALSignInProps {
	state: MSALSignInState;
	rootState: RootState;
}

class MSALSignIn extends React.Component<IMSALSignInProps,{}> {

	render(): React.ReactNode {

		let comboBoxOptions = this.props.state.storedTenants.map(t => {
			return {
				key: t.domain,
				text: t.domain,
			};
		});


		return <div
					style={{
						margin: '100px auto',
						boxShadow: 'rgb(36 0 74 / 40%) 0px 0px 15px 3px',
						maxWidth: '400px',
						padding: '25px',
						textAlign: 'center',
					}}
				>
					<img src={logo} alt="logo" style={{ height: 30, paddingLeft: 3 }} />

					<Label style={{ padding: 20 }}>
						Sign in using your Microsoft 365 account to start.
					</Label>

					<ComboBox 
						label='Tenant/SharePoint URL'
						placeholder='For multi-tenant access, e.g. acme.sharepoint.com'
						allowFreeform={true} 
						autoComplete={'on'}
						options={comboBoxOptions} 
						defaultSelectedKey={this.props.state.selectedTenantInfo?.domain}
						onChange={(e, selectedOption, i, value) => { this.props.state.setCurrentTenantUrl(value || ''); }}                            
						text={this.props.state.currentTenantUrl} />
					
					<DefaultButton 
						style={{margin:10}}
						onClick={() => { this.props.state.startLogin(); }}>	
						Sign in
					</DefaultButton>
				</div>
	}
}

export default observer(MSALSignIn);
